export const environment = {
  mode: import.meta.env.MODE,            // vite mode
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,
  appEnv: import.meta.env.VITE_APP_ENV,
  apiUrl: import.meta.env.VITE_API_URI,
  graphqlUrl: import.meta.env.VITE_GRAPHQL_URI,
  adClientId: import.meta.env.VITE_AD_CLIENT_ID,
  adAuthorizeUrl: import.meta.env.VITE_AD_AUTHORIZE_URL,
  adRedirectUri: import.meta.env.VITE_AD_REDIRECT_URI,
};